import DOMPurify from 'dompurify';

const FORMATTING_TAGS = [
  'b',
  'blockquote',
  'br',
  'div',
  'em',
  'h1',
  'h2',
  'i',
  'li',
  'ol',
  'p',
  'pre',
  's',
  'span',
  'strong',
  'strike',
  'u',
  'ul'
];

const LINK_TAGS = ['a'];
const LINK_ATTRIBUTES = ['href', 'rel', 'target'];
const SAFE_NOTE_URI_PATTERN = /^(?:(?:https?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))/i;

const NOTE_CONTENT_SANITIZER_CONFIG = {
  ALLOWED_TAGS: [...FORMATTING_TAGS, ...LINK_TAGS],
  ALLOWED_ATTR: LINK_ATTRIBUTES,
  ALLOWED_URI_REGEXP: SAFE_NOTE_URI_PATTERN
};

const sanitizeNoteContent = (html = '') => DOMPurify.sanitize(html || '', NOTE_CONTENT_SANITIZER_CONFIG);

export { NOTE_CONTENT_SANITIZER_CONFIG };
export default sanitizeNoteContent;
